// extracted by mini-css-extract-plugin
module.exports = {"icon":"onfido-sdk-ui-crossDevice-MobileConnected-icon","cancel":"onfido-sdk-ui-crossDevice-MobileConnected-cancel"};